module.exports = __webpack_public_path__ + "img/asesoriavisaestudiante.715ce138.png";